<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="应收明细账"
      show-summary
      :page="page"
      :queryParamsAppend="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="getDataFunc"
      urlHash="finance/dealings/inledgerdts"
      @reset="reset"
      @selectClick="selectClick"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="对账期间" label-width="100px">
          <el-date-picker
            @change="monthrangeChange"
            v-model="value"
            value-format="yyyy-MM-dd"
            style="width: 180px"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="对账周期" label-width="100px">
          <el-select v-model="params.Cycle" @change="cycleChange" clearable style="width: 180px">
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import tableColumn from '@/data/finance/dealings/inledgerdts/list.json'
import tableParam from '@/data/finance/dealings/inledgerdts/query.json'

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/rp/rpReceiptDoc').default,
      receiptApi: require('@/api/rp/receipt').default,
      value: [],
      params: {
        // Type: null,
        DocDateStart: null,
        DocDateEnd: null
        // MonthStart: null,
        // MonthEnd: null,
        // TradeUnitId: null,
        // TradeUnitName: "",
        //Cycle: "本月",
      },
      isMB: this.$store.state.isMB
    }
  },
  mounted() {
    if (!this.$permission.canPrice('/finance/dealings/inledgerdts')) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == 'NeedAmount')
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1)
      const findIndex1 = this.$refs.list.tableList.findIndex(item => item.tableName == 'AlreadyAmount')
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1)
      const findIndex2 = this.$refs.list.tableList.findIndex(item => item.tableName == 'LeftAmount')
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1)
    }
    var start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
    var end = this.$commonJs.getToday()
    const index = this.$refs.list.paramsData.findIndex(item => item.field == 'DocDateStart')
    this.$refs.list.paramsData[index].value[0] = this.params.DocDateStart = start
    this.$refs.list.paramsData[index].value[1] = this.params.DocDateEnd = end
    this.value = [start, start]
    this.monthrangeChange(this.value)
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd]
    },
    sDate() {
      return this.$dayjs().endOf('month').format('YYYY-MM-DD')
    },
    eDate() {
      return this.$dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD')
    }
  },
  // beforeMount() {
  //   var today = this.$commonJs.getToday();
  //   var arr = today.split("-");
  //   this.params.DocDateStart = arr[0] + "-" + arr[1] + "-01";
  //   var nextFirst = (arr[1] == "12" ?(Number(arr[0])+1):arr[0]) + "-" + (arr[1]=="12"?"01":(Number(arr[1])+1)) + "-01";
  //   var date = new Date(nextFirst);
  //   var time = date.getTime() - 86400000;
  //   this.params.DocDateEnd = this.$commonJs.toDateString(time)
  // },
  methods: {
    toURL(o) {
      this.$router.push(o)
    },
    selectClick(row) {
      console.log('row=====', row)

      if (row.SrcVouTypeName === '销货单') {
        let data = {
          DocId: row.SourceId
        }
        this.$router.push({
          name: 'editSale',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '其它应收单') {
        let data = {
          OtherReceivId: row.SourceId
        }
        this.$router.push({
          name: 'editOthereceive',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '收入单') {
        let data = {
          DocId: row.SourceId
        }
        this.$router.push({
          name: 'editIncome',
          params: { mode: 'edit', data }
        })
      }
      if (row.SrcVouTypeName === '冲销单') {
        this.$router.push({
          name: 'chargeoff',
          params: { DocNo: row.SourceNo }
        })
      }
      if (row.SrcVouTypeName === '收款单') {
        let id = row.SourceId

        this.receiptApi.info(id).then(res => {
          if (res.Code === 0) {
            this.toURL({
              name: 'editreceivables',
              params: {
                type: 'edit',
                data: res.Data
              }
            })
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      }
    },
    reset() {
      //  this.params.DocDateStart=undefined,
      //  this.params.DocDateEnd=undefined,
      this.value = []
      var start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
      this.value = [start, start]
      this.monthrangeChange(this.value)
    },
    monthrangeChange(t) {
      console.log(t, 't')
      if (this.params.Cycle) {
        this.$message.warning('对账期间与对账周期只能选择一个')
        this.value = []
        return false
      }
      const index = this.$refs.list.paramsData.findIndex(item => item.field == 'DocDateStart')
      if (!t) {
        this.$refs.list.paramsData[index].value = []
        this.params.DocDateStart = null
        this.params.DocDateEnd = null
        return
      }
      this.params.DocDateStart = t[0]
      var str = t[1].slice(5, 7)
      var year = t[1].slice(0, 4)
      var lastDate = new Date(year, str, 0).getDate()
      this.params.DocDateEnd = year + '-' + str + '-' + lastDate

      this.$refs.list.paramsData[index].value = []
      this.$refs.list.paramsData[index].value[0] = this.params.DocDateStart
      this.$refs.list.paramsData[index].value[1] = this.params.DocDateEnd
      console.log(this.params, 'this.params')
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        params = this.$commonJs.obj.removeNullKey({ ...params, ...this.params })
        const index = this.$refs.list.paramsData.findIndex(item => item.field == 'DocDateStart')
        if (this.$refs.list.paramsData[index].value) {
          var start = this.$refs.list.paramsData[index].value[0]
          var end = this.$refs.list.paramsData[index].value[1]
          if (start && !params.DocDateStart) {
            params.DocDateStart = start
          }
          if (end && !params.DocDateEnd) {
            params.DocDateEnd = end
          }
        } else {
          params.DocDateStart = null
          params.DocDateEnd = null

          if (this.value) {
            if (this.value.length > 0) {
              console.log(this.value, 'this.value')
              params.DocDateStart = this.value[0]

              var str = this.value[1].slice(5, 7)
              var year = this.value[1].slice(0, 4)
              var lastDate = new Date(year, str, 0).getDate()
              params.DocDateEnd = year + '-' + str + '-' + lastDate
            }
          }
        }

        if (!params.DocDateStart || !params.DocDateEnd) {
          this.$message.warning('请选择对账日期')
          resolve({ Data: [] })
        } else {
          this.api.getListDetailRcv(params).then(res => resolve(res))
        }
      })
    },
    // openTradeunit() {
    //   this.$refs.customer.open().then((that) => {
    //     that.getData();
    //   });
    // },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId
      this.params.TradeUnitName = data.FullName
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start
      this.params.DocDateEnd = val.End
    },
    monthChange(val) {
      this.params.MonthStart = val.Start
      this.params.MonthEnd = val.End
    },
    onExport() {
      var list = this.$refs.list
      var listParams = list.tempQueryParams
      var fields = list.tableList.map(x => x.tableName)
      var params = { ...listParams, Fields: fields.join(',') }
      var loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      this.api.export(params).then(() => {
        loading.close()
      })
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      console.log(this.value, 'this.value')
      if (this.value && this.value?.length > 0) {
        this.$message.warning('对账期间与对账周期只能选择一个')
        this.params.Cycle = ''
        return
      }
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }
      this.params.DocDateStart = start
      this.params.DocDateEnd = end
      this.vaule = []
      console.log(this.params)
      // this.query();
      const index = this.$refs.list.paramsData.findIndex(item => item.field == 'DocDateStart')
      this.$refs.list.paramsData[index].value = []
      this.$refs.list.paramsData[index].value[0] = this.params.DocDateStart
      this.$refs.list.paramsData[index].value[1] = this.params.DocDateEnd
    }
  }
}
</script>
